import React, { Component } from "react";
import { useState } from "react";
import {
  BrowserRouter,
  Route,
  Switch as Routes,
  Link,
  NavLink,
  useParams,
} from "react-router-dom";
import "../text.css";

export default function AlertHeaderPc3() {
  return (
    <>
      <div
        className="Light"
        style={{
          top: "0px",
          Width: "100%",
          backgroundColor: "#fafafa",
          zIndex: "10010",

          margin: "auto",
          marginTop: "10px",
          paddingTop: "40px",
          paddingBottom: "40px",
          fontSize: "18px",
          textAlign: "center",
          minWidth: "1400px",
          width: "100%",
        }}
      >
        <a className="Medium">
          <a style={{ color: "#4a64f5" }}>‘문자 상표’</a>와
          <a style={{ color: "#4a64f5" }}>‘로고 상표’</a>중 선택하여 출원을
          진행합니다.
        </a>
      </div>
    </>
  );
}
